import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { ProgressBar } from 'react-bootstrap';
import Pusher from '../../../../components/pusher';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';

class CollectorIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percentage: 0,
      total: 0,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUpdate(event) {
    const { collector } = this.props;
    if (event.error) {
      this.props.onError(event.error);
    } else if (collector.collector_id === event.collector_id && collector.collector_type === event.collector_type) {
      const { current, total } = event;
      const percentage = total !== 0 ? (current / total) * 100 : 0;
      const done = current === total;
      this.setState({ percentage, total, done });
    }
  }

  render() {
    const { collector, eventName } = this.props;
    const { percentage, done, total } = this.state;
    return (
      <div className="well well-sm">
        <div className="clearfix">
          <div className="pull-left">
            {done && <span><Fa name="check-circle" className="text-success animated flash" />&nbsp;</span>}
            {!done && <span><Fa name="spinner" spin className="text-muted" />&nbsp;</span>}
            <strong>{collector.collector_name}</strong>
          </div>
          <div className="pull-right text-right">
            <span className={done ? 'animated flash' : ''}>
              <Counter value={percentage}>
                <NumberDisplay value={percentage} suffix="%" />
              </Counter>
            </span>
          </div>
        </div>
        <Pusher
          key={eventName}
          event={eventName}
          handler={this.handleUpdate}
        />
        <ProgressBar active bsStyle="success" striped now={percentage} />
      </div>
    );
  }
}

CollectorIndicator.propTypes = {
  collector: PropTypes.shape({
    object: PropTypes.string,
    name: PropTypes.string,
    collector_id: PropTypes.string,
    collector_name: PropTypes.string,
    collector_type: PropTypes.string,
  }).isRequired,
  eventName: PropTypes.string.isRequired,
  onError: PropTypes.func,
};

CollectorIndicator.defaultProps = {
  onError: null,
};

export default CollectorIndicator;
